import React, { useState } from 'react';
import { Alert } from 'antd';

const KEY_PREFIX = 'cicloHint:';

/**
 * Hint de sección para las pantallas del ciclo. Explica en qué paso está el
 * usuario y qué se hace acá — parte de la capa de auto-evidencia (Fase 2).
 * Es descartable y se recuerda en localStorage por `id`, para que el ejecutivo
 * experto lo oculte y no vuelva a molestarlo.
 *
 * @param {string} id  clave estable para recordar el descarte (localStorage)
 * @param {React.ReactNode} message  título corto del hint
 * @param {React.ReactNode} [description]  explicación + CTA opcional
 */
function SectionHint({ id, message, description }) {
  const storageKey = `${KEY_PREFIX}${id}`;
  const [visible, setVisible] = useState(() => {
    try {
      return localStorage.getItem(storageKey) !== 'dismissed';
    } catch {
      return true;
    }
  });

  if (!visible) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(storageKey, 'dismissed');
    } catch {
      /* localStorage no disponible — se oculta igual esta sesión */
    }
    setVisible(false);
  };

  return (
    <Alert
      type="info"
      showIcon
      closable
      onClose={dismiss}
      message={message}
      description={description}
    />
  );
}

export default SectionHint;
